// Region and locale types for MTLI multi-site architecture

export type Region = 'CA' | 'US';
export type Locale = 'en-CA' | 'fr-CA' | 'en-US';

export interface RegionConfig {
  region: Region;
  locale: Locale;
  domain: string;
  phone: string;
  email: string;
  currency: string;
  headquarters: string;
  tagline: string;
}

export const REGION_CONFIGS: Record<Region, RegionConfig> = {
  CA: {
    region: 'CA',
    locale: 'en-CA',
    domain: 'mtli.ca',
    phone: '416-293-2176',
    email: 'info@mtli.ca',
    currency: 'CAD',
    headquarters: 'Toronto, Ontario',
    tagline: 'Serving North America Coast to Coast',
  },
  US: {
    region: 'US',
    locale: 'en-US',
    domain: 'mtligroup.com',
    phone: '305-433-7789',
    email: 'info@mtligroup.com',
    currency: 'USD',
    headquarters: 'Miami, Florida',
    tagline: 'Serving North America Coast to Coast',
  },
};

export const LOCALE_NAMES: Record<Locale, string> = {
  'en-CA': 'English',
  'fr-CA': 'Français',
  'en-US': 'English',
};

export const LOCALE_SHORT: Record<Locale, string> = {
  'en-CA': 'EN',
  'fr-CA': 'FR',
  'en-US': 'EN',
};
